module.exports = __webpack_public_path__ + "img/pdf.f7ed4460.svg";